import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_ngv: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export const initialSearchValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  ma_ngv: 'ALL',
  dien_giai: '',
  status: 'ALL',
  user_id0: 'ALL'
};

export type SearchFormValues = z.infer<typeof searchSchema>;

export const FormSchema = z.object({
  dien_giai: z.string().optional(),
  ghi_chu: z.string().optional(),
  e_mail: z.string().optional(),
  ty_gia: z.number().optional(),
  ngay_ct: z.string().optional(),
  ngay_lct: z.string().optional(),
  ngay_hl: z.string().optional(),
  so_hd: z.string().optional(),
  status: z.string().optional(),
  transfer_yn: z.boolean().optional(),
  ma_so_thue: z.string().optional(),
  ten_kh_thue: z.string().optional(),
  dia_chi: z.string().optional(),
  ong_ba: z.string().optional(),
  ma_nt: z.string().optional(),
  tong_tien: z.number().optional(),
  tong_chi_phi: z.number().optional(),
  tong_thue: z.number().optional(),
  tong_thanh_toan: z.number().optional(),
  tong_so_luong: z.number().optional(),
  dien_thoai: z.string().optional(),
  fax: z.string().optional(),
  ma_gd: z.string().optional(),
  ly_do_huy: z.string().optional(),
  so_ct: z.string().optional().nullable()
});

export const receiptVoucherSchema = z.object({
  ma_ngv: z.string().optional(),
  dia_chi: z.string().optional(),
  ong_ba: z.string().optional(),
  dien_giai: z.string().optional(),

  so_ct: z.string().optional().nullable(),
  ngay_ct: z.string().optional().nullable(),
  ngay_lct: z.string().optional().nullable(),

  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),

  status: z.string().optional(),
  transfer_yn: z.boolean().optional(),

  theo_doi_thanh_toan: z.boolean().optional(),
  so_ct0: z.string().optional().nullable(),
  ngay_ct0: z.string().optional().nullable(),

  ma_kh: z.string().optional().nullable(),
  so_ct_goc: z.coerce.number().optional(),
  dien_giai_ct_goc: z.string().optional(),

  t_tien_nt: z.string().optional(),
  t_tien: z.string().optional()
});

export type ReceiptVoucherFormData = z.infer<typeof receiptVoucherSchema>;

export const receiptVoucherInitialValues: ReceiptVoucherFormData = {
  ma_ngv: '1',
  dia_chi: '',
  ong_ba: '',
  dien_giai: '',

  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_lct: new Date().toISOString().split('T')[0],

  ma_nt: '',
  ty_gia: 1,
  status: '5',
  transfer_yn: false,

  theo_doi_thanh_toan: false,
  so_ct0: '',
  ngay_ct0: new Date().toISOString().split('T')[0],

  ma_kh: '',
  so_ct_goc: 0,
  dien_giai_ct_goc: '',
  t_tien_nt: '0',
  t_tien: '0'
};
